export default [
  {
    header: 'Accessibility',
  },
  // {
  //   title: 'Chat',
  //   route: 'apps-chats',
  //   icon: 'MessageCircleIcon',
  //   resource: 'Support',
  //   action: 'Support',
  // },
  {
    title: 'Support',
    icon: 'HeadphonesIcon',
    route: 'apps-allTickets',
    resource: 'admin',
    action: 'manage',
  },
  {
    title: 'Currencies',
    icon: 'DollarSignIcon',
    route: 'apps-currencies-manage-currencies',

  },
  {
    title: 'Game Reviews',
    icon: 'Edit2Icon',
    route: 'apps-game-reviews-list',
    resource: 'admin',
    action: 'manage',
  },
  {
    title: 'Wallet Networks',
    icon: 'CodepenIcon',
    resource: 'admin',
    action: 'manage',
    route: 'NetworksList',
  },
  {
    title: 'Games',
    icon: 'ApertureIcon',
    children: [
      {
        title: 'Create Game',
        route: 'apps-games-create-game',
      },
      {
        title: 'Manage Games',
        route: 'apps-games-manage-games',
      },
      {
        title: 'Platforms',
        route: 'apps-games-manage-platforms'
      },
      {
        title: 'Offers',
        route: 'apps-games-manage-offers'
      },
    ],

  },

  {
    title: 'Blogs',
    icon: 'BookOpenIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'Create',
        route: 'pages-blog-create',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Manage Blogs',
        route: 'pages-blog-list',
        resource: 'admin',
        action: 'manage',
      },

      {
        title: 'Authors Blogs',
        route: 'pages-blog-bloggers-blog-list',
        resource: 'admin',
        action: 'manage',
      },
    ],
  },
  {
    title: 'Users',
    icon: 'UserIcon',
    children: [
      {
        title: 'Manage Users',
        route: 'apps-users-list',
      },
      {
        title: 'Pro Requests',
        route: 'apps-users-pro-lists',
      },
      {
        title: 'Manage Wallets',
        route: 'apps-wallets-manage-wallets',
        resource: 'admin',
        action: 'manage',
      },

    ],
  },
  {
    title: 'Orders',
    icon: 'ListIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'All Orders',
        route: 'apps-orders-list',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Order Warranties',
        route: 'apps-orders-warranties',
      },

    ],
  },
  {
    title: 'Financial',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Payments List',
        route: 'apps-payments-list',
      },
      {
        title: 'Withdraw Requests List',
        route: 'apps-payments-withdraws',
      },

    ],
  },
  {
    title: 'Faqs',
    icon: 'HelpCircleIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'Create Faq',
        route: 'apps-site-setting-faqs-create-faq',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Manage Faqs',
        route: 'apps-site-setting-faqs-faqs',
        resource: 'admin',
        action: 'manage',
      },

    ],
  },
  {
    title: 'Pages',
    icon: 'BookIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'Create Page',
        route: 'apps-site-setting-create-page',
        resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Manage pages',
        route: 'apps-site-setting-dynamic-pages',
        resource: 'admin',
        action: 'manage',
      },

    ],
  },
  {
    title: 'Coupons',
    icon: 'AwardIcon',
    resource: 'admin',
    action: 'manage',
    children: [
      {
        title: 'Create Coupon',
        route: 'apps-site-setting-coupon-create-coupon',
         resource: 'admin',
        action: 'manage',
      },
      {
        title: 'Manage Coupons',
        route: 'apps-site-setting-coupon-manage-coupons',
         resource: 'admin',
        action: 'manage',
      },

    ],
  },
  {
    title: 'Reports',
    icon:'SettingsIcon',
    children: [
      {
        title: 'Payments Report',
        route: 'apps-reports-payments',
      },
      {
        title: 'Tips Report',
        route: 'apps-reports-tips',
      },
      {
        title: 'Rate Report',
        route: 'apps-reports-rate',
      },
    ]
  },
  {
    title: 'Site Setting',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Stripe Setting',
        route: 'apps-site-setting-stripe-setting',
      },
      {
        title: 'General Setting',
        route: 'apps-site-setting-general-setting',
      },
      {
        title: 'Delivery Setting',
        route: 'apps-site-setting-delivery-speed',
      },
      {
        title: 'Tips Config',
        route: 'apps-site-setting-tips-config',
      },
    ],
  },

]
